module.exports = __webpack_public_path__ + "static/media/error.38245c33.mp3";